import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import PropTypes from 'prop-types';

// Component
import { Row, Col, Select } from 'antd';

// Actions
import moment from 'moment';
import { changeLanguage } from '../../data/app/actions';

// Others
import packageJSON from '../../../../package.json';
import { strings } from '../../localization';

const { Option } = Select;

const Footer = ({ currentLang, languageOptions, changeLanguage }) => {
    const handleLanguageChange = value => {
        changeLanguage(value);
    };

    const langFlag = {
        sk: '🇸🇰',
        en: '🇺🇸',
        de: '🇩🇪',
        zh: '🇨🇳'
    };

    return (
        <Row type="flex" justify="center" align="middle">
            <Col xs={24}>
                <span>
                    {strings.appName} ©{moment().get('year')} | {strings.version}: {packageJSON.version}{' '}
                    |{' '}
                </span>
                <Select
                    size="small"
                    defaultValue={currentLang}
                    onChange={handleLanguageChange}
                    disabled={!(languageOptions && languageOptions.size > 0)}
                    data-testid="footer-lang-select"
                >
                    {languageOptions && languageOptions.size > 0
                        ? languageOptions.map(lang => (
                              <Option key={`available-lang-${lang}`} value={lang}>
                                  {langFlag[lang]} {strings.language[lang]}
                              </Option>
                          ))
                        : []}
                </Select>
            </Col>
        </Row>
    );
};

Footer.propTypes = {
    currentLang: PropTypes.string.isRequired,
    languageOptions: PropTypes.instanceOf(List).isRequired,
    changeLanguage: PropTypes.func.isRequired
};

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        currentLang: state.app.get('lang'),
        languageOptions: state.app.get('availableLanguages')
    }),
    {
        changeLanguage
    }
)(Footer);
